export const onInputChanged = ({ onChanged }) => event => {
  const { target } = event;
  if (!target) return;

  const { value: keyword } = target;
  if (typeof keyword !== "string") return;

  onChanged({
    event,
    keyword,
  });
};
